<template>
  <page>
    <container-layout
      :menu="menu"
      :showAside="false"
      :defaultMenu="defaultMenu"
      @selectMainMenu="selectMenu"
      router
    >
      <template v-slot:main>
        <div class="task-list-wrapper">
          <div class="title">
            <el-button type="primary" @click="addTask">新建任务</el-button>
          </div>
          <pagination-table
            :data="data"
            :columns="columns"
            :actions="actions"
            :loader="getWarningList"
            :async="true"
            :pageSizes="[10]"
            class="dot-table"
            colWidth="400px"
          ></pagination-table>
        </div>
        <el-dialog
          v-drag:common
          title="处理操作提示"
          :visible.sync="uploadDialog.visible"
        >
          <div v-if="headers.state === 0" class="upload-wrapper">
            <div style="display: flex">
              <span style="color: #fff">上传撰写文件：</span>
              <el-upload
                ref="upload"
                :action="action"
                :auto-upload="false"
                :data="headersFile"
                :on-success="onFileUploadSuccess"
                :file-list="fileList"
                :on-change="onChange"
                :limit="1"
                :on-exceed="handleExceed"
                accept=".xls, .xlsx, .txt, .doc, .docx"
              >
                <el-button size="mini" type="primary">点击上传</el-button>
              </el-upload>
            </div>

            <!-- <a :href="downLoadUrl" class="down-load">下载</a> -->
            <div slot="footer" class="dialog-footer" style="textAlign: center">
              <el-button @click="uploadDialog.visible = false">取消</el-button>
              <el-button type="primary" @click="submitUpLoadFile"
                >确定</el-button
              >
            </div>
          </div>
          <div v-else>
            <el-form label-width="80px" :model="headers" label-position="left">
              <el-form-item label="处理意见">
                <el-input
                  v-model="headers.memo"
                  type="textarea"
                  :maxlength="200"
                  rows="3"
                ></el-input>
              </el-form-item>
              <el-form-item label="数据文件" label-width="80px">
                <el-upload
                  ref="upload"
                  :action="action"
                  :auto-upload="false"
                  :data="headers"
                  :on-success="onFileUploadSuccess"
                  :on-change="onChange"
                  :limit="1"
                  :on-exceed="handleExceed"
                  accept=".xls, .xlsx, .txt, .doc, .docx"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="textAlign: center">
              <el-button @click="submitUpLoad(2)" style="marginRight: 20px"
                >不同意</el-button
              >
              <el-button type="primary" @click="submitUpLoad(1)"
                >同意</el-button
              >
            </div>
          </div>
        </el-dialog>
        <add-dialog
          :visible.sync="visible"
          @close="closeAddDialog"
          :id="id"
          :type="type"
        ></add-dialog>
        <detail-dialog
          :visible.sync="detailVisible"
          @close="closeDetailDialog"
          :id="id"
        ></detail-dialog>
      </template>
    </container-layout>
  </page>
</template>
<script>
import { getToken } from '@/utils';
import { getMenu } from './util';
import AddDialog from './component/add-dialog';
import DetailDialog from './component/detail-dialog';
const defaultHeaders = {
  workId: null,
  state: null,
  memo: '',
  apiKey: getToken(),
  result: null
};
const defaultheadersFile = {
  apiKey: getToken(),
  workId: null,
  state: 0,
  memo: '',
  result: 1
};
export default {
  components: { AddDialog, DetailDialog },
  data() {
    return {
      id: '',
      type: '',
      detailVisible: false,
      visible: false,
      file: '',
      downLoadUrl: '',
      fileList: [],
      headers: {
        workId: null,
        state: null,
        memo: '',
        apiKey: getToken(),
        result: null
      },
      headersFile: {
        apiKey: getToken(),
        workId: null,
        state: 0,
        memo: '',
        result: 1
      },
      uploadDialog: {
        loading: false,
        visible: false
      },
      action: `${process.env.VUE_APP_API_HOST_WORK}/cowork/project/otherUpload`,
      // actionFile: `${process.env.VUE_APP_API_HOST_WORK}/cowork/project/upload`,
      defaultMenu: '/task/list',
      data: [],
      columns: [
        {
          prop: 'workName',
          label: '项目名称'
        },
        {
          prop: 'stateType',
          label: '状态',
          width: '110px'
        },
        {
          prop: 'name',
          label: '创建人',
          width: '200px'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '180px'
        }
      ],
      actions: [
        {
          label: '详情',
          type: 'success',
          plain: true,
          style: 'btn',
          onClick: (index, row) => {
            this.id = row.workId;
            //console.log(this.id, 'this.id...');
            this.detailVisible = true;
          }
        },
        {
          label: '处理',
          type: 'warning',
          plain: false,
          style: 'btn',
          disable: row => {
            return row.updateFlag === '0';
          },
          onClick: (index, row) => {
            this.uploadDialog.visible = true;
            this.headers.state = row.state;
            this.headers.workId = row.workId;
            this.headersFile.workId = row.workId;
            //console.log(`第${index}行, row value: ${row.state}`);
            this.downLoadUrl = `${
              process.env.VUE_APP_API_HOST_WORK
            }/cowork/project/coworkDown?apiKey=${getToken()}&workId=${
              row.workId
            }`;
          }
        },
        {
          label: '编辑',
          type: 'info',
          plain: true,
          style: 'btn',
          disable: row => {
            return row.createFlag === '0';
          },
          onClick: (index, row) => {
            this.id = row.workId;
            this.visible = true;
            this.type = 'edit';
          }
        }
        // {
        //   label: '下载',
        //   type: 'success',
        //   style: 'link',
        //   href: (index, row) => {
        //     return `${process.env.VUE_APP_API_HOST_WORK}/cowork/project/coworkDown?apiKey=${getToken()}&workId=${row.workId}`;
        //   }
        // }
      ]
    };
  },
  computed: {
    menu() {
      return getMenu(code => this.$hasPermission(code));
    }
  },
  methods: {
    selectMenu() {},
    onChange(file) {
      this.file = file;
    },
    addTask() {
      this.visible = true;
      this.type = 'add';
    },
    // 使用组件的属性控制，故暂时废弃下方代码
    // beforeAvatarUpload(file) {
    //   const testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
    //   const isxls = testmsg === 'xls'
    //   const isxlsx = testmsg === 'xlsx'
    //   const istxt = testmsg === 'txt'
    //   const isdoc = testmsg === 'doc'
    //   if(!isxls && !isxlsx && !istxt && !isdoc) {
    //     this.$message({
    //         message: '只能上传xls, xlsx, txt, doc的类型文件',
    //         type: 'warning'
    //     });
    //   }
    //   return isxls || isxlsx || istxt || isdoc
    // },
    handleExceed() {
      return this.$message({
        message: '最多只能上传一个文件',
        type: 'error'
      });
    },
    async closeAddDialog() {
      this.visible = false;
      await this.getWarningList({ page: 0 });
    },
    closeDetailDialog() {
      this.detailVisible = false;
    },
    async getWarningList(options) {
      //console.log(options, 'options..');

      const { data } = await this.$fetch.get('/cowork/project/getCoworkList', {
        module: 'work',
        params: { pageNo: options.page }
      });
      const { data: resData } = data;
      //console.log(resData, 'this.data//table');
      this.data = resData.rows.map(item => {
        if (item.state === 0) {
          item.stateType = '撰写中';
        } else if (item.state === 5) {
          item.stateType = '完成';
        } else if (item.state === 1) {
          item.stateType = '检阅中';
        } else if (item.state === 2) {
          item.stateType = '验查中';
        } else if (item.state === 3) {
          item.stateType = '会签中';
        } else if (item.state === 4) {
          item.stateType = '核定中';
        }
        return item;
      });
      return {
        data: this.data,
        total: resData.total
      };
    },
    async onFileUploadSuccess(response) {
      this.uploadDialog.visible = false;
      this.headers = { ...defaultHeaders };
      this.headersFile = { ...defaultheadersFile };
      this.$refs.upload.clearFiles();
      this.file = '';
      if (response.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        });
        location.reload();
        return;
      }
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    onFileSelectError() {
      this.uploadDialog.visible = false;
      this.uploadDialog.loading = false;
      this.file = '';
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    async submitUpLoad(result) {
      this.headers.result = result;
      if (result === 2 && !this.headers.memo) {
        return this.$message({
          message: '请填写处理意见',
          type: 'error'
        });
      }
      if (!this.file) {
        const params = this.headers;
        await this.$postForm({
          url: '/cowork/project/otherUpload',
          module: 'work',
          data: {
            ...params
          },
          showLoading: true,
          showError: true
        });
        location.reload();
      }

      this.$refs.upload.submit();
      this.uploadDialog.visible = false;
    },
    async submitUpLoadFile() {
      if (!this.file) {
        return this.$message({
          message: '请上传文件',
          type: 'error'
        });
      }
      this.$refs.upload.submit();
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-button--primary:focus,
.el-button--primary:hover {
  background-color: #3271a1;
  border-color: #3271a1;
}
.task-list-wrapper {
  padding: 0px 28px;
  .title {
    color: #ffffff;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 4px;
  }
}
/deep/.container-layout .container-layout-content > .el-main {
  border: none !important;
}
/deep/.el-dialog {
  .el-textarea__inner {
    background-color: transparent;
    color: #fff;
  }
  .upload-wrapper {
    // display: flex;
    // align-items: flex-start;
    padding-top: 15px;
    .down-load {
      color: green;
      display: inline-block;
      margin-left: 30px;
      margin-right: 40px;
    }

    .dialog-footer {
      text-align: right;
      margin-top: 40px;
    }
  }

  .el-dialog__body {
    padding-left: 16px;
    padding-top: 10px;

    .el-upload {
      min-width: 200px;
      text-align: left;
    }
  }
  /deep/.el-form-item__label {
    color: #fff;
  }
  /deep/.el-input__inner {
    width: 300px;
    background-color: transparent;
    color: #ffffff;
    border: none;
    border-bottom: 1px solid #ffffff;
    border-radius: 0;
  }
}
</style>
<style lang="less">
.el-tooltip__popper.is-dark {
  max-width: 200px !important;
}
</style>
